module.exports = __webpack_public_path__ + "static/media/portfolio-example-07.cdd20c54.jpg";